import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Outlet } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LoadingSpinner from './components/LoadingSpinner';
import CursorGlow from './components/CursorGlow';
import SolutionsNavigation from './components/SolutionsNavigation';
import AnalyticsTracker from './components/AnalyticsTracker';
import Home from './pages/Home';
import LendSmart from './pages/LendSmart';
import DeepFlow from './pages/DeepFlow';
import Niyukti from './pages/Niyukti';
import QSM from './pages/QSM';
import TenderLens from './pages/TenderLens';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Blog from './pages/Blog';

// Initialize Google Analytics 4 (only in production to avoid polluting data)
const GA_MEASUREMENT_ID = 'G-62QVSF5LV4';

if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize(GA_MEASUREMENT_ID);
} else {
  console.log('GA4: Running in development mode - analytics disabled');
}

// ScrollToTop and Loading component
const ScrollToTop = ({ setLoading }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Show loading spinner
    setLoading(true);
    window.scrollTo(0, 0);

    // Hide loading spinner after a short delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [pathname, setLoading]);

  return null;
}

// Layout component for pages with Navbar and Footer
const Layout = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col page-enter">
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  const [loading, setLoading] = useState(true);

  // Initial page load
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <CursorGlow />
      <SolutionsNavigation />
      {loading && <LoadingSpinner />}
      <ScrollToTop setLoading={setLoading} />
      <AnalyticsTracker />
      <Routes>
        {/* Routes without Navbar/Footer */}
        <Route path="/login" element={<Login />} />

        {/* Routes with Navbar/Footer */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/products/lendsmart" element={<LendSmart />} />
          <Route path="/products/deepflow" element={<DeepFlow />} />
          <Route path="/products/niyukti" element={<Niyukti />} />
          <Route path="/products/qsm" element={<QSM />} />
          <Route path="/products/tenderlens" element={<TenderLens />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
